export default "__VITE_ASSET__BJA46O$L__"